export const saveToPortfolioAsyncModule = {
  importFn: () => import(/* webpackChunkName: "save-to-portfolio" */ './module-entry'),
  cacheKey: 'save-to-portfolio',
}
